// src/state-management/admin/offer/actionTypes.js
export const ADD_OFFER_REQUEST = 'ADD_OFFER_REQUEST';
export const ADD_OFFER_SUCCESS = 'ADD_OFFER_SUCCESS';
export const ADD_OFFER_FAILURE = 'ADD_OFFER_FAILURE';
